var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2008_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2013 10.8646V10.8633C11.1325 10.8683 10.7781 10.8896 9.9875 10.8896C9.35625 10.8896 8.91187 10.8708 8.75562 10.8633V10.8652C6.32562 10.7583 4.51187 10.3352 4.51187 9.82896C4.51187 9.32333 6.32562 8.90021 8.75562 8.79146V10.444C8.91437 10.4552 9.36937 10.4821 9.99812 10.4821C10.7525 10.4821 11.1306 10.4508 11.2013 10.4446V8.79271C13.6263 8.90084 15.4356 9.32396 15.4356 9.82896C15.4356 10.3352 13.6263 10.7571 11.2013 10.8646V10.8646ZM11.2013 8.62084V7.14209H14.585V4.88708H5.37188V7.14209H8.75562V8.62021C6.00562 8.74646 3.9375 9.29146 3.9375 9.94396C3.9375 10.5965 6.00562 11.1408 8.75562 11.2677V16.0065H11.2013V11.2665C13.9469 11.1402 16.01 10.5958 16.01 9.94396C16.01 9.29208 13.9469 8.74771 11.2013 8.62084",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2008_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.d071bb8e925500fb1cf35fda6e8dd4e3.svg";
export { ForwardRef as ReactComponent };